import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import saveAs from 'file-saver';

import i18next from 'i18next'

import UploadPopup from './UploadPopup'

import { setSignedFileForVerifyEu, setShowUploadpopup, setFileListEuVerify, setSizeOfFilesEu, setEuVerifyResult, setShowAdwancedReport, setSelectedCa } from "../actions/localStates"
import { formatDate, fromBytes } from "../actions/helpers"

import { jsPDF } from "jspdf";

import '../fonts/Roboto-Regular-normal.js';
import '../fonts/Roboto-Bold-normal.js';

import Dropzone from 'react-dropzone';
const dropzoneRef = createRef();


class EUVerifyView extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
      		files: this.props.verify.fileListEu || [],
      		sizeOfFiles: this.props.verify.sizeOfFiles || 0
	    }

	    this.handleOnDrop = this.handleOnDrop.bind(this);

	    this.verifyResults = this.verifyResults.bind(this);

	    this.showAdvancedReportHendler = this.showAdvancedReportHendler.bind(this);

	    this.downloadXmlDataToFile = this.downloadXmlDataToFile.bind(this);
	    this.downloadPdfReport = this.downloadPdfReport.bind(this);

	    this.selectCA = this.selectCA.bind(this);

	    this.showAddButton = this.showAddButton.bind(this);

	    this.downloadETCIXml = this.downloadETCIXml.bind(this);
	}

	componentDidMount () {
    	this.fileInputSelector = this.buildFileInputSelector();
    }

    componentDidUpdate(prevProps) {
		if (prevProps.verify.fileListEu !== this.props.verify.fileListEu) {
			this.setState({"files": this.props.verify.fileListEu})
		}

		if (prevProps.verify.sizeOfFiles !== this.props.verify.sizeOfFiles) {
			this.setState({"sizeOfFiles": this.props.verify.sizeOfFiles})
		}
	}

	buildFileInputSelector () {
		const fileInputSelector = document.getElementById('fileInputUpload');
		return fileInputSelector;
	}

	showAdvancedReportHendler () {
		this.props.actions.setShowAdwancedReport(!this.props.verify.showAdvancedReport)
		document.activeElement.blur()
	}

	onChangeSignedFile (e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setSignedFileForVerifyEu(e.target.files[0])
		}
	}

	selectCA (e) {
		this.props.actions.setSelectedCa(e.target.value)
	}

	handleSignedFile (e) {
		e.preventDefault();
		this.fileInputSelector.value = null;
	    this.fileInputSelector.click()
	    document.activeElement.blur()
	}

	handleOnDrop (files) {
		if (files[0] !== undefined && (files[0].size < 104857600)) {
			this.props.actions.setSignedFileForVerifyEu(files[0])
		}
	}

	cleanUpFileInputSelect () {
		this.props.actions.setSignedFileForVerifyEu(null)
		this.props.actions.setFileListEuVerify(null);
		this.props.actions.setSizeOfFilesEu(0)
	}

	deleteItem (id) {
		const files = this.state.files
		var allFilesSize = this.state.sizeOfFiles

		allFilesSize = allFilesSize - files[id].size
		this.setState({"sizeOfFiles": allFilesSize})
		this.props.actions.setSizeOfFilesEu(allFilesSize)

		files.splice(id, 1)

		this.setState({"files": files}, () => {
			this.props.actions.setFileListEuVerify(files);
		})
	}

	clearData () {
		this.props.actions.setSignedFileForVerifyEu(null)
		this.props.actions.setFileListEuVerify(null);
		this.props.actions.setSizeOfFilesEu(0)
		this.props.actions.setEuVerifyResult(null)
		this.props.actions.setShowAdwancedReport(false)
	}

	showUploadFilesPopup () {
		this.props.actions.setShowUploadpopup(true)
	}

	verify () {
		this.props.verifyData()
	}

	showAddButton (file) {
		var extension;
		extension = file.name.split('.').pop();

		if (extension === 'pdf' || extension.includes("asic")) {
			return false
		} else {
			return true
		}
	}

	downloadXmlDataToFile () {
		var blob;
    	const b64toBlob = (b64Data, contentType, sliceSize=512) => {
		  const byteCharacters = atob(b64Data);
		  const byteArrays = [];

		  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		    const slice = byteCharacters.slice(offset, offset + sliceSize);

		    const byteNumbers = new Array(slice.length);
		    for (let i = 0; i < slice.length; i++) {
		      byteNumbers[i] = slice.charCodeAt(i);
		    }

		    const byteArray = new Uint8Array(byteNumbers);
		    byteArrays.push(byteArray);
		  }

		  const blob = new Blob(byteArrays);
		  return blob;
		}

		blob = b64toBlob(this.props.verify.euVerifyResult.additionalValidationReports["DSS_DIAGNOSTIC_DATA_XML"]);

		var today = new Date();
		var dd = String(today.getDate()).padStart(2, '0');
		var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
		var yyyy = today.getFullYear();

		today = dd + '-' + mm + '-' + yyyy;
		
		//current-date
		saveAs(blob, "diagnostic-data-" + today + ".xml")
	}

	downloadETCIXml () {
		var blob;
    	const b64toBlob = (b64Data, contentType, sliceSize=512) => {
		  const byteCharacters = atob(b64Data);
		  const byteArrays = [];

		  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		    const slice = byteCharacters.slice(offset, offset + sliceSize);

		    const byteNumbers = new Array(slice.length);
		    for (let i = 0; i < slice.length; i++) {
		      byteNumbers[i] = slice.charCodeAt(i);
		    }

		    const byteArray = new Uint8Array(byteNumbers);
		    byteArrays.push(byteArray);
		  }

		  const blob = new Blob(byteArrays);
		  return blob;
		}

		blob = b64toBlob(this.props.verify.euVerifyResult.additionalValidationReports["ETSI_VALIDATION_REPORT"]);
	

		saveAs(blob, "Validation_of_" + (this.props.verify.signedFile.name.substring(0, this.props.verify.signedFile.name.lastIndexOf('.')) || this.props.verify.signedFile.name) + ".xml")
	}

	downloadPdfReport () {
		var doc = new jsPDF(), verticalOffset = 35, i, res, str = "", dataWidth, img, _this = this;
		
		
		var result = this.props.verify.euVerifyResult.additionalValidationReports["CIPHER_SIMPLE_JSON_REPORT"]

		// var content = result.validationPolicy["description"].toString().split('\n');
		// content = String(content).replace('\n','');

		function addHeader () {

			switch (_this.props.base.clientStyle) {
	          case 'infotech':
	          	img = 'data:image/png;base64,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'
	            
	            doc.addImage(img, 'PNG', 10, 5, 55, 25)
	            doc.setFont('Roboto-Regular', 'normal');
				doc.setFontSize(8);
		   		doc.text("Державне підприємство «ІНФОТЕХ»", 200, 9, {align:'right'});
		   		doc.text("04050, Україна, м. Київ, вул Дегтярівська 15Б", 200, 12, {align:'right'});
		   		doc.text("Тел.: +38 (044) 363 43 34", 200, 20, {align:'right'});
		   		// doc.text("Факс: +38 (044) 483-0322", 200, 23, {align:'right'});
		   		doc.textWithLink("E-mail: info@infotech.gov.ua", 200, 23, {align:'right'});
		   		doc.line(10, 30, 200, 30);
	            break;    

	          case 'eis':
	          	img = 'data:image/png;base64,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'

	          	doc.setFont('Roboto-Regular', 'normal');
		
				doc.addImage(img, 'PNG', 10, 5, 45, 15)

				doc.setFontSize(8);
		   		doc.text("Державне підприємство «ІНФОТЕХ»", 200, 9, {align:'right'});
		   		doc.text("04050, Україна, м. Київ, вул Дегтярівська 15Б", 200, 12, {align:'right'});
		   		doc.text("Тел.: +38 (044) 363 43 34", 200, 20, {align:'right'});
		   		// doc.text("Факс: +38 (044) 483-0322", 200, 23, {align:'right'});
		   		doc.textWithLink("E-mail: info@infotech.gov.ua", 200, 23, {align:'right'});
		   		doc.textWithLink("Web: infotech.gov.ua", 200, 26, {url: 'www.infotech.gov.ua', align:'right'});
		   		doc.line(10, 29, 200, 29);
		   		break;

	          case 'default':
	          	img = 'data:image/png;base64,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'
                doc.setFont('Roboto-Regular', 'normal');

				// var str = this.generateTextResult();
				
				doc.addImage(img, 'PNG', 10, 8, 40, 15)

				doc.setFontSize(8);
		   		doc.text("ТОВ Сайфер ПРО", 200, 8, {align:'right'});
		   		doc.text("Україна, 04070, вул. Волоська 51/27б, 2 офіс", 200, 12, {align:'right'});
		   		doc.text("Тел.: +38 (044) 484-4612", 200, 16, {align:'right'});
		   		doc.text("Факс: +38 (044) 483-0322", 200, 20, {align:'right'});
		   		doc.textWithLink("E-mail: info@cipher.com.ua", 200, 24, {align:'right'});
		   		doc.textWithLink("Web: www.cipher.com.ua", 200, 28, {url: 'www.cipher.com.ua', align:'right'});
		   		doc.line(10, 29, 200, 29);
		   		break;

	          default:
	          	img = 'data:image/png;base64,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'
	            doc.setFont('Roboto-Regular', 'normal');

				// var str = this.generateTextResult();
				
				doc.addImage(img, 'PNG', 10, 5, 40, 20)

				doc.setFontSize(8);
		   		doc.text("Сайфер ПРО, ТОВ", 200, 8, {align:'right'});
		   		doc.text("04107, Київ, вул. Нагірна 25/27, 3-ій поверх", 200, 12, {align:'right'});
		   		doc.text("Тел.: +38 (044) 484-4612", 200, 16, {align:'right'});
		   		doc.text("Факс: +38 (044) 483-0322", 200, 20, {align:'right'});
		   		doc.textWithLink("E-mail: info@cipher.com.ua", 200, 24, {align:'right'});
		   		doc.textWithLink("Web: www.cipher.com.ua", 200, 28, {url: 'www.cipher.com.ua', align:'right'});
		   		doc.line(10, 29, 200, 29);
		   		break;
	        }
			
		}

		if (this.props.verify.showAdvancedReport) {
			addHeader()

			doc.setFont('Roboto-Bold', 'normal');
   			doc.setFontSize(18);
			doc.text(i18next.t("protocol"), 105, 36, {align:'center'});

	   		doc.setFontSize(10);
	   		doc.setFont('Roboto-Regular', 'normal');
	   		doc.text(i18next.t("dsValidation"), 105, 42, {align:'center'});

			doc.setFontSize(10);
	   		doc.setFont('Roboto-Regular', 'normal');

	   		verticalOffset += 14

	   		doc.setFont("Roboto-Bold", 'normal');
	   		doc.text(i18next.t("fileNameWithDS"), 10, verticalOffset);

	   		doc.setFont("Roboto-Regular", 'normal');
	   		doc.text(this.props.verify.signedFile.name, 55, verticalOffset);

	   		verticalOffset += 6

	   		doc.setFont("Roboto-Bold", 'normal');
	   		doc.text(i18next.t("fileSizeWithDS"), 10, verticalOffset);

			res = this.props.actions.fromBytes(this.props.verify.signedFile.size);
			str = res.value + " " + i18next.t(res.unit);

	   		doc.setFont("Roboto-Regular", 'normal');
	   		doc.text(str, 56, verticalOffset);

	   		verticalOffset += 6

			doc.setFont('Roboto-Bold', 'normal');
			doc.text(i18next.t("validationDateTime"), 10, verticalOffset);

			doc.setFont('Roboto-Regular', 'normal');
			doc.text(this.props.actions.formatDate(result.validationDateTime), 50, verticalOffset);

	   		verticalOffset += 6
	   		doc.setFont('Roboto-Bold', 'normal');
	   		doc.text(i18next.t("name"), 10, verticalOffset);

	   		doc.setFont('Roboto-Regular', 'normal');

	   		verticalOffset += 4

	   		var someText = result.validationPolicy["description"].replace(/\r?\n|\r/g, "");
	   		someText = someText.replace('   ','');
	   		someText = someText.replace('    ',' ');
	   		someText = someText.replace('  ','');
			doc.text(someText, 10, verticalOffset, {align:'justify', maxWidth: 180});

			verticalOffset += 17

			doc.text(result.validationPolicy["name"], 10, verticalOffset);

			verticalOffset += 5
			doc.text(result.validationPolicy["hash"], 10, verticalOffset);

			verticalOffset += 6
			doc.setFont('Roboto-Bold', 'normal');
			doc.text(i18next.t("validationProcess"), 10, verticalOffset);

			verticalOffset += 4
			doc.setFont('Roboto-Regular', 'normal');
			doc.text(i18next.t(result.validationProcess), 10, verticalOffset, {align:'justify', maxWidth: 180});

			dataWidth = doc.getTextWidth(result.validationProcess, 10)
			if (dataWidth < 27) {
				verticalOffset += 6
			} else {
				verticalOffset += 10
			}

			if (result.asicContainerType) {

				doc.setFont('Roboto-Bold', 'normal');
				doc.text(i18next.t("asicContainerType"), 10, verticalOffset);
				doc.setFont('Roboto-Regular', 'normal');
				doc.text(i18next.t(result.asicContainerType), 40, verticalOffset);

				verticalOffset += 6
			}

			str = "" + result.signaturesCount
			doc.setFont('Roboto-Bold', 'normal');
			doc.text(i18next.t("signaturesCount"), 10, verticalOffset);
			doc.setFont('Roboto-Regular', 'normal');
			doc.text(str, 99, verticalOffset);

			verticalOffset += 6

			str = "" + result.validSignaturesCount
			doc.setFont('Roboto-Bold', 'normal');
			doc.text(i18next.t("validSignaturesCount"), 10, verticalOffset);
			doc.setFont('Roboto-Regular', 'normal');
			doc.text(str, 148, verticalOffset);

			for (i = 0; i < result.signatureReports.length; i += 1) {
				if (verticalOffset + 70 > 290) {
					verticalOffset = 35;
					doc.addPage();

					addHeader()

					doc.setFontSize(10);
				}

				verticalOffset += 8

				if (result.signatureReports[i].isValid) {
					doc.setTextColor("green");
				} else {
					doc.setTextColor("red");
				}

				doc.setFont('Roboto-Bold', 'normal');
				doc.text(i18next.t("es") + (i + 1) + ": ", 10, verticalOffset);
				
				doc.text(result.signatureReports[i].isValid ? i18next.t("heIsValid") : i18next.t("heIsInvalid"), 48, verticalOffset);

				doc.setFont('Roboto-Regular', 'normal');
				doc.setTextColor("black");

				if (result.signatureReports[i].certificateChain.length > 0) {
					verticalOffset += 6

					doc.setFont('Roboto-Bold', 'normal');
					doc.text(i18next.t("signer"), 10, verticalOffset);

					doc.setFont('Roboto-Regular', 'normal');
					doc.text(result.signatureReports[i].certificateChain[0].ownerCommonName, 32, verticalOffset);
				}

				verticalOffset += 6
				doc.setFont('Roboto-Bold', 'normal');
				doc.text(i18next.t("indication"), 10, verticalOffset);

				verticalOffset += 4
				doc.setFont('Roboto-Regular', 'normal');
				doc.text(i18next.t(result.signatureReports[i].indication), 10, verticalOffset);

				
				if (result.signatureReports[i].subIndication) {
					verticalOffset += 6
					doc.setFont('Roboto-Bold', 'normal');
					doc.text(i18next.t("subIndication"), 10, verticalOffset);

					verticalOffset += 4
					doc.setFont('Roboto-Regular', 'normal');
					doc.text(i18next.t(result.signatureReports[i].subIndication), 10, verticalOffset);
				}


				verticalOffset += 6
				doc.setFont('Roboto-Bold', 'normal');
				doc.text(i18next.t("bestSignatureDateTime"), 10, verticalOffset);
				doc.setFont('Roboto-Regular', 'normal');
				doc.text(this.props.actions.formatDate(result.signatureReports[i].bestSignatureDateTime), 144, verticalOffset);

				verticalOffset += 6
				doc.setFont('Roboto-Bold', 'normal');
				doc.text(i18next.t("signatureFormat"), 10, verticalOffset);
				doc.setFont('Roboto-Regular', 'normal');
				doc.text(i18next.t(result.signatureReports[i].signatureFormat), 39, verticalOffset);

				verticalOffset += 6
				doc.setFont('Roboto-Bold', 'normal');
				doc.text(i18next.t("signatureQualification"), 10, verticalOffset);

				verticalOffset += 4
				doc.setFont('Roboto-Regular', 'normal');
				doc.text(i18next.t(result.signatureReports[i].signatureQualification), 10, verticalOffset);

				verticalOffset += 6
				doc.setFont('Roboto-Bold', 'normal');
				doc.text(i18next.t("signedDateTime"), 10, verticalOffset);
				doc.setFont('Roboto-Regular', 'normal');
				doc.text(this.props.actions.formatDate(result.signatureReports[i].signedDateTime), 87, verticalOffset);

				if (result.signatureReports[i].certificateChain.length > 0) {
					verticalOffset += 6
					doc.setFont('Roboto-Bold', 'normal');
					doc.text(i18next.t("serialNumber"), 10, verticalOffset);
					verticalOffset += 4
					doc.setFont('Roboto-Regular', 'normal');
					doc.text(result.signatureReports[i].certificateChain[0].serialNumber, 10, verticalOffset);
				}

				if (result.signatureReports[i].certificateChain.length > 0) {
					verticalOffset += 6
					doc.setFont('Roboto-Bold', 'normal');
					doc.text(i18next.t("certificateChain"), 10, verticalOffset);

					doc.setFont('Roboto-Regular', 'normal');

					// eslint-disable-next-line
					result.signatureReports[i].certificateChain.slice(0).reverse().map((child) => {
						verticalOffset += 4
						doc.text(child.ownerCommonName, 10, verticalOffset);
						return null
					})
				}

				if (Object.keys(result.signatureReports[i].timestamps).length !== 0) {
					// eslint-disable-next-line
					result.signatureReports[i].timestamps.map((timestamp, index) => {
						if (verticalOffset + 70 > 290) {
							verticalOffset = 35;
							doc.addPage();

							addHeader()

							doc.setFontSize(10);
						}

						verticalOffset += 6

						if (timestamp.isValid) {
							doc.setTextColor("green");
						} else {
							doc.setTextColor("red");
						}

						doc.setFont('Roboto-Bold', 'normal');
						doc.text(i18next.t("timestampsLabel") + (i + 1 + ". ") + (index + 1) + ": ", 10, verticalOffset);
						// doc.setFont('Roboto-Bold', 'normal');
						doc.text(timestamp.isValid ? i18next.t("sheIsValid") : i18next.t("sheIsInvalid"), 63, verticalOffset);

						doc.setFont('Roboto-Regular', 'normal');
						doc.setTextColor("black");

						verticalOffset += 5
						doc.setFont('Roboto-Bold', 'normal');
						doc.text(i18next.t("indication"), 10, verticalOffset);

						verticalOffset += 4
						doc.setFont('Roboto-Regular', 'normal');
						doc.text(i18next.t(timestamp.indication), 10, verticalOffset, {align:'justify', maxWidth: 180});

						dataWidth = doc.getTextWidth(timestamp.indication, 10)

						// var head2Text = doc.splitTextToSize(timestamp.indication,570,{fontSize:12});
						// const head2FinalHeight = doc.getTextDimensions(head2Text,{fontSize:10});
						if (dataWidth < 28) {
							verticalOffset += 6
						} else {
							verticalOffset += 10
						}

						if (timestamp.subIndication) {

							doc.setFont('Roboto-Bold', 'normal');
							doc.text(i18next.t("subIndication"), 10, verticalOffset);

							verticalOffset += 4
							doc.setFont('Roboto-Regular', 'normal');
							doc.text(i18next.t(timestamp.subIndication), 10, verticalOffset, {align:'justify', maxWidth: 180});

							// if (dataWidth < 28) {
							// 	verticalOffset += 6
							// } else {
							// 	verticalOffset += 12
							// }
						}

						verticalOffset += 6
						doc.setFont('Roboto-Bold', 'normal');
						doc.text(i18next.t("productionDateTime"), 10, verticalOffset);
						doc.setFont('Roboto-Regular', 'normal');
						doc.text(this.props.actions.formatDate(timestamp.productionDateTime), 108, verticalOffset);

						verticalOffset += 6
						doc.setFont('Roboto-Bold', 'normal');
						doc.text(i18next.t("timestampType"), 10, verticalOffset);
						doc.setFont('Roboto-Regular', 'normal');
						doc.text(i18next.t(timestamp.timestampType), 45, verticalOffset);

						if (timestamp.certificateChain.length > 0) {
							verticalOffset += 6
							doc.setFont('Roboto-Bold', 'normal');
							doc.text(i18next.t("serialNumberTsp"), 10, verticalOffset);

							verticalOffset += 4
							doc.setFont('Roboto-Regular', 'normal');
							doc.text(timestamp.certificateChain[0].serialNumber, 10, verticalOffset);
						}

						if (timestamp.certificateChain.length > 0) {
							verticalOffset += 6
							doc.setFont('Roboto-Bold', 'normal');
							doc.text(i18next.t("certificateChain"), 10, verticalOffset);

							doc.setFont('Roboto-Regular', 'normal');
							timestamp.certificateChain.slice(0).reverse().map((child, index) => {
								verticalOffset += 4
								doc.text(child.ownerCommonName, 10, verticalOffset);
								return null
							})
						}
						return null
					})


				}
			}
		} else {
			addHeader()

			doc.setFont('Roboto-Bold', 'normal');
   			doc.setFontSize(18);
			doc.text(i18next.t("protocol"), 105, 36, {align:'center'});

	   		doc.setFontSize(10);
	   		doc.setFont('Roboto-Regular', 'normal');
	   		doc.text(i18next.t("dsValidation"), 105, 42, {align:'center'});

			doc.setFontSize(10);
	   		doc.setFont('Roboto-Regular', 'normal');

	   		verticalOffset += 14

			doc.setFontSize(10);

	   		doc.setFont("Roboto-Bold", 'normal');
	   		doc.text(i18next.t("fileNameWithDS"), 10, verticalOffset);

	   		doc.setFont("Roboto-Regular", 'normal');
	   		doc.text(this.props.verify.signedFile.name, 55, verticalOffset);

	   		verticalOffset += 6

	   		doc.setFont("Roboto-Bold", 'normal');
	   		doc.text(i18next.t("fileSizeWithDS"), 10, verticalOffset);

			res = this.props.actions.fromBytes(this.props.verify.signedFile.size);
			str = res.value + " " + i18next.t(res.unit);

	   		doc.setFont("Roboto-Regular", 'normal');
	   		doc.text(str, 56, verticalOffset);

	   		verticalOffset += 6
			doc.setFont('Roboto-Bold', 'normal');
			doc.text(i18next.t("validationDateTime"), 10, verticalOffset);

			doc.setFont('Roboto-Regular', 'normal');
			doc.text(this.props.actions.formatDate(result.validationDateTime), 50, verticalOffset);

			for (i = 0; i < result.signatureReports.length; i += 1) {
				if (verticalOffset + 70 > 290) {
					verticalOffset = 35;
					doc.addPage();

					addHeader()

					doc.setFontSize(10);
				}

				verticalOffset += 12

				if (result.signatureReports[i].isValid) {
					doc.setTextColor("green");
				} else {
					doc.setTextColor("red");
				}

				doc.setFont('Roboto-Bold', 'normal');
				doc.text(i18next.t("es") + (i + 1) + ": ", 10, verticalOffset);
				doc.setFont('Roboto-Regular', 'normal');
				doc.text(result.signatureReports[i].isValid ? i18next.t("heIsValid") : i18next.t("heIsInvalid"), 48, verticalOffset);

				doc.setTextColor("black");

				if (result.signatureReports[i].certificateChain.length > 0) {
					verticalOffset += 6

					doc.setFont('Roboto-Bold', 'normal');
					doc.text(i18next.t("signer"), 10, verticalOffset);

					doc.setFont('Roboto-Regular', 'normal');
					doc.text(result.signatureReports[i].certificateChain[0].ownerCommonName, 32, verticalOffset);
				}

				verticalOffset += 6
				doc.setFont('Roboto-Bold', 'normal');
				doc.text(i18next.t("signatureFormat"), 10, verticalOffset);
				doc.setFont('Roboto-Regular', 'normal');
				doc.text(i18next.t(result.signatureReports[i].signatureFormat), 39, verticalOffset);

				verticalOffset += 6
				doc.setFont('Roboto-Bold', 'normal');
				doc.text(i18next.t("signatureQualification"), 10, verticalOffset);
				verticalOffset += 6
				doc.setFont('Roboto-Regular', 'normal');
				doc.text(i18next.t(result.signatureReports[i].signatureQualification), 10, verticalOffset);

				verticalOffset += 6
				doc.setFont('Roboto-Bold', 'normal');
				doc.text(i18next.t("signedDateTime"), 10, verticalOffset);
				doc.setFont('Roboto-Regular', 'normal');
				doc.text(this.props.actions.formatDate(result.signatureReports[i].signedDateTime), 87, verticalOffset);

				if (result.signatureReports[i].certificateChain.length > 0) {
					verticalOffset += 6
					doc.setFont('Roboto-Bold', 'normal');
					doc.text(i18next.t("certificateChain"), 10, verticalOffset);

					doc.setFont('Roboto-Regular', 'normal');

					// eslint-disable-next-line
					result.signatureReports[i].certificateChain.slice(0).reverse().map((child) => {
						verticalOffset += 6
						doc.text(child.ownerCommonName, 10, verticalOffset);
						return null
					})
				}

				if (Object.keys(result.signatureReports[i].timestamps).length !== 0) {
					// eslint-disable-next-line
					result.signatureReports[i].timestamps.map((timestamp, index) => {
						if (verticalOffset + 70 > 290) {
							verticalOffset = 35;
							doc.addPage();

							addHeader()

							doc.setFontSize(10);
						}

						verticalOffset += 8

						if (timestamp.isValid) {
							doc.setTextColor("green");
						} else {
							doc.setTextColor("red");
						}

						doc.setFont('Roboto-Bold', 'normal');
						doc.text(i18next.t("timestampsLabel") + (i + 1 + ". ") + (index + 1) + ": ", 10, verticalOffset);
						doc.setFont('Roboto-Regular', 'normal');
						doc.text(timestamp.isValid ? i18next.t("sheIsValid") : i18next.t("sheIsInvalid"), 63, verticalOffset);

						doc.setTextColor("black");

						verticalOffset += 6
						doc.setFont('Roboto-Bold', 'normal');
						doc.text(i18next.t("productionDateTime"), 10, verticalOffset);
						doc.setFont('Roboto-Regular', 'normal');
						doc.text(this.props.actions.formatDate(timestamp.productionDateTime), 108, verticalOffset);

						verticalOffset += 6
						doc.setFont('Roboto-Bold', 'normal');
						doc.text(i18next.t("timestampType"), 10, verticalOffset);
						doc.setFont('Roboto-Regular', 'normal');
						doc.text(i18next.t(timestamp.timestampType), 45, verticalOffset);

						if (timestamp.certificateChain.length > 0) {
							verticalOffset += 6
							doc.setFont('Roboto-Bold', 'normal');
							doc.text(i18next.t("certificateChain"), 10, verticalOffset);

							doc.setFont('Roboto-Regular', 'normal');
							timestamp.certificateChain.slice(0).reverse().map((child, index) => {
								verticalOffset += 6
								doc.text(child.ownerCommonName, 10, verticalOffset);
								return null
							})
						}
						return null
					})
				}
			}
		}

		doc.save("verify-result-" + this.props.verify.signedFile.name + ".pdf")
	}

	verifyResults () {
		let rootDiv = [], divPtblg = [], es = [], esFrames = [], validationPolicy = [];
		var result = this.props.verify.euVerifyResult.additionalValidationReports["CIPHER_SIMPLE_JSON_REPORT"]

		console.log(this.props.verify.euVerifyResult.additionalValidationReports["CIPHER_SIMPLE_JSON_REPORT"])

		var res, fileSize = "";
		res = this.props.actions.fromBytes(this.props.verify.signedFile.size);
		fileSize = res.value + " " + i18next.t(res.unit);

		divPtblg.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
			<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
				{
					i18next.t("fileNameWithDS")
				}
			</div>
			<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
				{
					this.props.verify.signedFile.name
				}
			</div>
		</div>)

		divPtblg.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
			<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
				{
					i18next.t("fileSizeWithDS")
				}
			</div>
			<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
				{
					fileSize
				}
			</div>
		</div>)

		divPtblg.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
			<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
				{
					i18next.t("validationDateTime")
				}
			</div>
			<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
				{
					this.props.actions.formatDate(result.validationDateTime)
				}
			</div>
		</div>)

		validationPolicy.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
				<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
					{
						i18next.t("name")
					}
				</div>
				<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
					<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
						<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							{
								result.validationPolicy["description"]
							}
						</div>
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
						<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							{
							result.validationPolicy["name"]
						}
						</div>
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
						<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							{
								result.validationPolicy["hash"]
							}
						</div>
					</div>
				</div>
			</div>)

		if (this.props.verify.showAdvancedReport) {
			divPtblg.push(validationPolicy)
		}

		if (this.props.verify.showAdvancedReport) {
			divPtblg.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
				<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
					{
						i18next.t("validationProcess")
					}
				</div>
				<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
					{
						i18next.t(result.validationProcess)
					}
				</div>
			</div>)
		}

		if (result.asicContainerType !== null && result.asicContainerType !== undefined) {
			divPtblg.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
				<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
					{
						i18next.t("asicContainerType")
					}
				</div>
				<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
					{
						i18next.t(result.asicContainerType)
					}
				</div>
			</div>)
		}

		if (this.props.verify.showAdvancedReport) {
			divPtblg.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
				<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
					{
						i18next.t("signaturesCount")
					}
				</div>
				<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
					{
						result.signaturesCount
					}
				</div>
			</div>)
		}

		if (this.props.verify.showAdvancedReport) {
			divPtblg.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
				<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
					{
						i18next.t("validSignaturesCount")
					}
				</div>
				<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
					{
						result.validSignaturesCount
					}
				</div>
			</div>)
		}

		for (var i = 0; i < result.signatureReports.length; i += 1) {
			es.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 es-container">
				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0">
					<div className={result.signatureReports[i].isValid ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0 font-size-es-head is-valid" : "col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0 font-size-es-head is-invalid"}>
						<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px", paddingBottom: "10px"}}>
							{
								i18next.t("es") + (i + 1)
							}
						</div>
						<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12 font-weight-bold" style={{paddingTop: "10px"}}>
							{
								result.signatureReports[i].isValid ? i18next.t("heIsValid") : i18next.t("heIsInvalid")
							}
						</div>
					</div>

					{
						result.signatureReports[i].certificateChain.length > 0
						? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0">
							<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
								{
									i18next.t("signer")
								}
							</div>
							<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
								{
									result.signatureReports[i].certificateChain[0].ownerCommonName
								}
							</div>
						</div>
						: null
					}
					

					{
						this.props.verify.showAdvancedReport
						? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0">
							<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
								{
									i18next.t("indication")
								}
							</div>
							<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
								{
									i18next.t(result.signatureReports[i].indication)
								}
							</div>
						</div>
						: null
					}

					{
						this.props.verify.showAdvancedReport && result.signatureReports[i].subIndication
						? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0">
							<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
								{
									result.signatureReports[i].subIndication ? i18next.t("subIndication") : null
								}
							</div>
							<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
								{
									i18next.t(result.signatureReports[i].subIndication)
								}
							</div>
						</div>
						: null
					}

					{
						this.props.verify.showAdvancedReport
						? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0">
							<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
								{
									i18next.t("bestSignatureDateTime")
								}
							</div>
							<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
								{
									this.props.actions.formatDate(result.signatureReports[i].bestSignatureDateTime)
								}
							</div>
						</div>
						: null
					}
				
					<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0">
						<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
							{
								i18next.t("signatureFormat")
							}
						</div>
						<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
							{
								i18next.t(result.signatureReports[i].signatureFormat)
							}
						</div>
					</div>

					<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0">
						<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
							{
								i18next.t("signatureQualification")
							}
						</div>
						<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
							{
								i18next.t(result.signatureReports[i].signatureQualification)
							}
						</div>
					</div>

					<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0">
						<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
							{
								i18next.t("signedDateTime")
							}
						</div>
						<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
							{
								this.props.actions.formatDate(result.signatureReports[i].signedDateTime)
							}
						</div>
					</div>

					{
						this.props.verify.showAdvancedReport && result.signatureReports[i].certificateChain.length > 0
						? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0">
							<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
								{
									i18next.t("serialNumber")
								}
							</div>
							<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
								{
									result.signatureReports[i].certificateChain[0].serialNumber
								}
							</div>
						</div>
						: null
					}

					{
						result.signatureReports[i].certificateChain.length > 0
						? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0" style={{paddingTop: "10px"}}>
							<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
								{
									i18next.t("certificateChain")
								}
							</div>
							<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
								{
									// eslint-disable-next-line
									result.signatureReports[i].certificateChain.slice(0).reverse().map((child, index) => {
										var className = "margin-left-" + index
										return(

											<div key={index} className={className} style={{paddingTop: "10px"}}>
												{/*<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
													{
														i18next.t("issuerDn") + ": " + child.issuerDn
													}
												</div>*/}
												<div className={result.signatureReports[i].certificateChain.length - 1 === index ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 font-weight-bold" : "col-lg-12 col-md-12 col-sm-12 col-xs-12"}>
													<i className="fa fa-link" style={{marginRight: "5px"}}></i>
													{
														child.ownerCommonName
													}
												</div>
												{/*<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
													{
														i18next.t("serialNumber") + child.serialNumber
													}
												</div>*/}
											</div>)
									})
								}
							</div>
						</div>
						: null
					}
				</div>

				{
					Object.keys(result.signatureReports[i].timestamps).length !== 0
					? <div>
						{
							// eslint-disable-next-line
							result.signatureReports[i].timestamps.map((timestamp, index) => {
								return (
									<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0 ts-container">
										<div className={timestamp.isValid ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0 font-size-es-head is-valid" : "col-lg-12 col-md-12 col-sm-12 col-xs-12 row row-0 row-padding-0 font-size-es-head is-invalid"}>
											<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px", paddingBottom: "10px"}}>
												{
													i18next.t("timestampsLabel") + (i + 1 + ". ") + (index + 1)
												}
											</div>
											<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12 font-weight-bold" style={{paddingTop: "10px", paddingBottom: "10px"}}>
												{
													timestamp.isValid ? i18next.t("sheIsValid") : i18next.t("sheIsInvalid")
												}
											</div>
										</div>
										{
											this.props.verify.showAdvancedReport
											? <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
													{
														i18next.t("indication")
													}
												</div>
											: null
										}
										{
											this.props.verify.showAdvancedReport
											? <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
													{
														i18next.t(timestamp.indication)
													}
												</div>
											: null
										}

										{
											this.props.verify.showAdvancedReport && timestamp.subIndication
											? <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
													{
														i18next.t("subIndication")
													}
											</div>
											: null
										}
										{	
											this.props.verify.showAdvancedReport && timestamp.subIndication
											? <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
													{
														i18next.t(timestamp.subIndication)
													}
												</div>
											: null
										}
										<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
											{
												i18next.t("productionDateTime")
											}
										</div>
										<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
											{
												this.props.actions.formatDate(timestamp.productionDateTime)
											}
										</div>

										<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
											{
												i18next.t("timestampType")
											}
										</div>
										<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
											{
												i18next.t(timestamp.timestampType)
											}
										</div>

										{
											this.props.verify.showAdvancedReport && timestamp.certificateChain.length > 0
											? <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
													{
														i18next.t("serialNumberTsp")
													}
											</div>
											: null
										}
										{	
											this.props.verify.showAdvancedReport && timestamp.certificateChain.length > 0
											? <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
													{
														timestamp.certificateChain[0].serialNumber
													}
												</div>
											: null
										}

										{
											timestamp.certificateChain.length > 0
											? <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
												{
													i18next.t("certificateChain")
												}
											</div>
											: null
										}
										
										<div className="col-lg-7 col-md-7 col-sm-12 col-xs-12" style={{paddingTop: "10px"}}>
											{
												timestamp.certificateChain.slice(0).reverse().map((child, index) => {
													var className = "margin-left-" + index
													return(

														<div key={index} className={className}>
															{/*<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
																{
																	i18next.t("issuerDn") + ": " + child.issuerDn
																}
															</div>*/}
															<div className={timestamp.certificateChain.length - 1 === index ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 font-weight-bold" : "col-lg-12 col-md-12 col-sm-12 col-xs-12"}>
																<i className="fa fa-link" style={{marginRight: "5px", paddingBottom: "10px"}}></i>
																{
																	child.ownerCommonName
																}
															</div>
															{/*<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
																{
																	i18next.t("serialNumber") + child.serialNumber
																}
															</div>*/}
														</div>)
												})
											}
										</div>
									</div>

								)
							})
						}
					  </div>
					: null
				}
			</div>)
		}

		esFrames.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginTop: "10px"}}>
				{
					es
				}
			</div>)
		divPtblg.push(esFrames)

		rootDiv.push(<div id="divPtblg">{divPtblg}</div>)
        return rootDiv
	}

	render() {
		return (
			<div>
				{
					this.props.verify.euVerifyResult
					? <div>
						<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{textAlign: "right"}}>
							<button className="btn btn-default" onClick={this.clearData.bind(this)}>{i18next.t("verifyOther")}</button>
						</div>
						<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{paddingTop: "10px"}}>
							<div className="card">
								<div className="card-header">
								    {i18next.t("verifyResultsTitle")}
								</div>
								<div className="card-body">
									<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
										<label style={{"cursor": "pointer"}}>
			                                <input className="form-check-input" type="checkbox" checked={this.props.verify.showAdvancedReport === true} onChange={this.showAdvancedReportHendler} />
			                                <span className="form-check-label">{i18next.t("advancedReport")}</span>
			                            </label>
			                            {
			                            	this.props.verify.euVerifyResult.additionalValidationReports["DSS_DIAGNOSTIC_DATA_XML"]
			                            	? <button className="btn btn-default" style={{marginLeft: "10px"}} onClick={this.downloadXmlDataToFile}>{i18next.t("downloadXmlData")}</button>
			                            	: null
			                            }
			                            <button className="btn btn-default" style={{marginLeft: "10px"}} onClick={this.downloadPdfReport}>{i18next.t("downloadPdfReport")}</button>
			                            <button className="btn btn-default" style={{marginLeft: "10px"}} onClick={this.downloadETCIXml}>{i18next.t("downloadEtsiReport")}</button>
									</div>
									{
										this.verifyResults()
									}
								</div>
							</div>
						</div>
					  </div>
					: <div className="row">
						
						<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{paddingTop: "10px"}}>
							<div className="card">
								<div className="card-header">
								    {i18next.t("veifyTitle")}
								</div>
								<div className="card-body">
									<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 row row-0 row-padding-0">
										<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 row row-0 row-padding-0">
											<label className="row-padding-0" style={{"cursor": "pointer"}}>
				                                <input className="form-check-input" type="radio" value="uk" checked={this.props.verify.selectedCA === 'uk'} onChange={this.selectCA} />
				                                <span className="form-check-label" style={{"paddingLeft": "7px"}}>{i18next.t("ukVerifyTitle")}</span>
				                            </label>
										</div>
										<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 row row-0 row-padding-0">
											<label className="row-padding-0" style={{"cursor": "pointer"}}>
				                                <input className="form-check-input" type="radio" value="eu" checked={this.props.verify.selectedCA === 'eu'} onChange={this.selectCA} />
				                                <span className="form-check-label" style={{"paddingLeft": "7px"}}>{i18next.t("euVerifyTitle")}</span>
				                            </label>
										</div>
									</div>
									<div className="row no-left-right-padding">
		                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("signedFile")}</label>
		                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">

		                                	{
		                              			this.props.verify.signedFile
		                              			? <div>
		                              				<div className="uploaded-files-div">
		                              					{this.props.verify.signedFile.name}<i className="fa fa-trash trash-icon" title={i18next.t("deleteTitle")} aria-hidden="true"  onClick={this.cleanUpFileInputSelect.bind(this)}></i>
		                              				</div>
													{/*<input type="text" className="form-control" value={this.props.verify.signedFile.name} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleSignedFile.bind(this)} readOnly />
													<div className="input-group-append">
												      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileInputSelect.bind(this)}>{i18next.t("cleanup")}</button>
												    </div>*/}
												</div>
							                    : <Dropzone ref={dropzoneRef} onDrop={this.handleOnDrop} multiple={false}>
							                        {({getRootProps, getInputProps}) => (
							                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropFile">
							                                <input {...getInputProps()} />
							                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitle")}</p>
							                            </div>
							                        )}
							                    </Dropzone>
		                              		}

				                        </div>
				                        <input id="fileInputUpload" type="file" onChange={this.onChangeSignedFile.bind(this)} style={{"display": "none"}} />

					                </div>

					                <div className="row no-left-right-padding">
					                	{
		                          			this.props.verify.fileListEu !== null && this.props.verify.fileListEu.length > 0
		                          			? <div>
		                          				<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{this.props.verify.fileListEu.length > 1 ? i18next.t("originalFiles") : i18next.t("originalFile")}</label>
		                          				{
		                          					this.props.verify.fileListEu.map((n, index) => {
													    return (<div className="uploaded-files-div" key={index}>
					                              					{n.name}<i className="fa fa-trash trash-icon" title={i18next.t("deleteTitle")} aria-hidden="true" onClick={this.deleteItem.bind(this, index)}></i>
					                              				</div>)
													})
		                          				}
		                          			  </div>
		                          			: null
		                          		}
					                </div>

					                <div className="row no-left-right-padding">
					                	{
		                          			this.props.verify.signedFile
		                          			? <div style={{paddingTop: "10px"}}>
		                          					<button className="btn btn-default" onClick={this.verify.bind(this)}>{i18next.t("validate")}</button>
		                          					{
		                          						this.showAddButton(this.props.verify.signedFile)
		                          						? i18next.t("or")
		                          						: null
		                          					}
		                          					{
		                          						this.showAddButton(this.props.verify.signedFile)
		                          						? <button className="btn btn-default" onClick={this.showUploadFilesPopup.bind(this)}>{i18next.t("addOriginalFiles")}</button>
		                          						: null
		                          					}
		                          			  </div>
		                          			: null
		                          		}
					                </div>
					                
								</div>
							</div>
						</div>
						{
							this.props.verify.showUploadPopup
							? <UploadPopup />
							: null
						}
					</div>
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        verify: state.eUVerifyReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	setSignedFileForVerifyEu,
    	setShowUploadpopup, setFileListEuVerify,
    	setSizeOfFilesEu, formatDate, setEuVerifyResult,
    	setShowAdwancedReport, fromBytes, setSelectedCa
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EUVerifyView);